import { render } from "./CellActions.vue?vue&type=template&id=3720a30e&scoped=true"
import script from "./CellActions.vue?vue&type=script&lang=js"
export * from "./CellActions.vue?vue&type=script&lang=js"

import "./CellActions.vue?vue&type=style&index=0&id=3720a30e&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3720a30e"]])

export default __exports__